// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1D8OL","colBig":"styles_colBig__36339","colSmall":"styles_colSmall__WwarE"};